import mustache from 'mustache';

import { Campground_Data, Trip_Cluster_v2, Trip_leg_v2 } from "../../util/tripPlanner_types";
import { get_cluster, get_pois_for_stop, getCityAutofill, getSaveTripBtn, getShareTripBtn, getTripDirections, getTripHTML, recalc, remove_poi, reorder_stops, saveTrip, send_addCustomStayToStop, send_copilot_req, send_removeStay, send_updateTripNotes, send_updateTripWishes, update_interests, updateStopRadius, updateTripState } from "../api_utils";
import { genie_wishes_added_disp } from "../templates";
import { filter_potential_stays, remove_avoid_area, set_tripFilters } from "../trip_utils";
import {  display_route, display_trip, display_trip_html, init_perLeg_routeOptions_listeners, set_filters_display } from "../tripPlanner_scripts";
import { display_potential_stays, display_wishes_stopPopout, hide_map_loadingIcon, show_map_loadingIcon, sort_stays, stopPopout_display_added_stays, update_stayRadius_histogram } from "../ui_utils";
import { add_custom_stay_to_stop, handle_add_poi_click, remove_stay_from_stop } from "../update_trip_utils";
import { distance_latLong_toMi, getHash, getTrip_cachedForm, handleSharePopup, levenshteinDistance, meter_to_mi, setCookie } from '../../util/general_util';
import { center_map, display_POI_pins, display_potential_stay_pins, remove_POI_pins, update_stayPin_opacity, zoomToStop } from '../map/map_displays';
import { get_genieMatches, get_selected_legs_for_recalc, get_stop_from_stopID, inc_interaction_counter, reverseTrip, savedTrip_noChanges } from '../util/helper_functions';
import { clearLayer, enlargeIcon, getPoiMarker_fromPoiId, shrinkIcon } from '../map/helper_functions';
import { handle_copilot_resp } from '../copilot_scripts';
import { display_pois } from '../util/poi_functions';
import { open_calendar } from '../calendar_utils';

export const close_event = new CustomEvent("element.hide", {
    bubbles: false,
    cancelable: true
});
export const show_event = new CustomEvent("element.show", {
    bubbles: false,
    cancelable: true
});


export async function handle_addWishes_click() {
    const addWishesEl:JQuery<HTMLElement> = $(this);
    const stopID = addWishesEl.attr("stopID");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    const stop = stopData.stop;
    const legIndex = stopData.legIndex;
    const stopIndex = stopData.stopIndex;

    const wrapper:JQuery<HTMLElement> = addWishesEl.closest("[stopWishesWrapper]");
    if (wrapper.length == 0) return;
    const stopWishes_list = wrapper.find("[stopWishes_list]")

    const wishes_items =stopWishes_list.find("li").map(function(idx,el) {return el.innerHTML}).toArray();

    if (stop.wishes) {
        stop.wishes.push(...wishes_items);
    } else {
        stop.wishes = [...wishes_items];
    };

    $(mustache.render(genie_wishes_added_disp,{})).insertAfter(addWishesEl);
    addWishesEl.remove();

    await send_updateTripWishes([{
        legIndex: legIndex,
        stopIndex: stopIndex,
        wishes: stop.wishes
    }]);

    // display_wishes_stopPopout(stop);

    const tripHTML = await getTripHTML(window.tripPlannerCurrentTrip);
    window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
    display_trip_html(window.tripPlannerCurrentTrip, true);

    inc_interaction_counter();

};

export function handle_saveTrip_form() {
    $("#saveTripIcon").addClass("d-none");
    $("#saveTripLoading").removeClass("d-none");

    if (window.tripPlannerCurrentTrip.tripID) {
        //already saved trip
        saveTrip(window.tripPlannerCurrentTrip, window.tripPlannerCurrentTrip.name, false).then(tripID => {
            setTimeout(() => {
                $("#saveTripIcon").removeClass("d-none");
                $("#saveTripLoading").addClass("d-none");
            }, 500);
            window.initTripState = getHash(JSON.stringify(getTrip_cachedForm(window.tripPlannerCurrentTrip)));
        }).catch(e => {
            console.error(e);
        });
    } else {
        //saving for first time
        const tripName = $(this).find("input[type='text']").val().toString();
        saveTrip(window.tripPlannerCurrentTrip, tripName, false).then(tripID => {
            window.tripPlannerCurrentTrip.tripID = tripID;
            window.history.replaceState({}, document.title, `/tripPlanner?id=${tripID}`);
            setTimeout(() => {
                $("#saveTripIcon").removeClass("d-none");
                $("#saveTripLoading").addClass("d-none");
            }, 500);

            window.initTripState = getHash(JSON.stringify(getTrip_cachedForm(window.tripPlannerCurrentTrip)));

            getSaveTripBtn().then(btnHtml => {
				$("#saveTripWrap").html(btnHtml);
                $("#saveTripForm").off("submit");
				$("#saveTripForm").on("submit", handle_saveTrip_form);
			}).catch(e => {
				console.error(e);
			});

            getShareTripBtn().then(btnHtml => {
                $("#shareTripWrap").html(btnHtml);
                $("[tripPrivacyBtn]").off("click");
                $("[tripPrivacyBtn]").on("click", handleSharePopup);
            });

            $("#tripName").html(tripName);

        }).catch(e => {
            console.error(e);
        });
    };
}

function init_genie_btn_draggable() {
    const draggable = document.getElementById("personalGenieBtn");
    let isDragging = false;
    let startX:number, startY:number, initialX:number, initialY:number;

    draggable.addEventListener("mousedown", startDrag);
    draggable.addEventListener("touchstart", startDrag);
    function startDrag(event:any) {
        const touchEvent = event.type === "touchstart";
        event.preventDefault();

        startX = touchEvent ? event.touches[0].clientX : event.clientX;
        startY = touchEvent ? event.touches[0].clientY : event.clientY;
        initialX = draggable.offsetLeft;
        initialY = draggable.offsetTop;

        isDragging = false;

        if (touchEvent) {
            document.addEventListener("touchmove", onDragMove);
            document.addEventListener("touchend", endDrag);
        } else {
            document.addEventListener("mousemove", onDragMove);
            document.addEventListener("mouseup", endDrag);
        }
    };

    function onDragMove(event:any) {
        const touchEvent = event.type === "touchmove";
        const currentX = touchEvent ? event.touches[0].clientX : event.clientX;
        const currentY = touchEvent ? event.touches[0].clientY : event.clientY;
        const dx = currentX - startX;
        const dy = currentY - startY;

        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
            isDragging = true;
            draggable.style.left = initialX + dx + "px";
            draggable.style.top = initialY + dy + "px";
        }
    }

    function endDrag(event:MouseEvent) {
        const touchEvent = event.type === "touchend";

        if (touchEvent) {
            document.removeEventListener("touchmove", onDragMove);
            document.removeEventListener("touchend", endDrag);
        } else {
            document.removeEventListener("mousemove", onDragMove);
            document.removeEventListener("mouseup", endDrag);
        }

        if (!isDragging) {
            const copilotScreen = document.getElementById("copilotInput")
            $(copilotScreen).removeClass("d-none");
            window.scrollTo(0,document.body.scrollHeight);
            copilotScreen.dispatchEvent(new CustomEvent("element.show", {
                bubbles: false,
                cancelable: true
            }));
        };
    };
};

export function init_generalUI_listeners() {
    $("#avoid-area-input_preSearch").on("input", function() {
        const input = $(this);
        const val = input.val().toString();
        if (val.length > 0) {
            getCityAutofill(val).then(html => {
                $("#avoid-area-autofill_preSearch").html(html);
                $("#avoid-area-autofill_preSearch").find(".search-suggestion").on("click", function() {
                    const query_str = $(this).attr("query_str");

                    const new_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                    const newAvoidArea:{id:string,name:string,bounds:null} = {
                        id: new_id,
                        name: query_str,
                        bounds: null
                    };

                    const new_avoid_entry = $("<div avoid-area-entry-wrap=''>");
                    new_avoid_entry.addClass("d-flex align-items-center justify-content-between p-2 border-bottom");
                    new_avoid_entry.append($(`<div avoid-area-name="">${query_str}</div>`));
                    new_avoid_entry.append($("<i class='ai-trash fs-lg' role='button' rem-avoid-area-entry=''></i>"));
                    new_avoid_entry.attr("id", new_id);

                    $("#avoid-area-entries_preSearch").append(new_avoid_entry);
                    new_avoid_entry.find("[rem-avoid-area-entry]").on("click", function() {
                        $(this).closest("[avoid-area-entry-wrap]").remove();
                    });
                    // $("#avoid-area-collapse_preSearch").collapse("show");
                    setTimeout(() => {
                        $("#avoid-area-autofill_preSearch").html("");
                        $("#avoid-area-autofill_preSearch").hide();
                    }, 200);
                });
            });
        } else {
            $("#avoid-area-autofill_preSearch").html("");
            $("#add-avoid-area_preSearch").hide();
        };
    });
    $("#avoid-area-input_preSearch").on("focusout", function(event) {
        setTimeout(() => {
            $("#avoid-area-autofill_preSearch:not(:hover)").hide();
        }, 200);
        if ($(this).val().toString().length == 0) {
            $("#avoid-area-autofill_preSearch").html("");
        };
    });
    $("#avoid-area-input_preSearch").on("focusin", () => {
        $("#avoid-area-autofill_preSearch").show();
    });



    $("#avoid-area-input").on("input", function() {
        const input = $(this);
        const val = input.val().toString();
        if (val.length > 0) {
            getCityAutofill(val).then(html => {
                $("#avoid-area-autofill").html(html);
                $("#avoid-area-autofill").find(".search-suggestion").on("click", function() {
                    const query_str = $(this).attr("query_str");

                    const new_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                    const newAvoidArea:{id:string,name:string,bounds:null} = {
                        id: new_id,
                        name: query_str,
                        bounds: null
                    };

                    if (window.tripPlannerCurrentTrip.filters.avoidAreas) {
                        window.tripPlannerCurrentTrip.filters.avoidAreas.push(newAvoidArea);
                    } else {
                        window.tripPlannerCurrentTrip.filters.avoidAreas = [newAvoidArea];
                    };

                    const new_avoid_entry = $("<div avoid-area-entry-wrap=''>");
                    new_avoid_entry.addClass("d-flex align-items-center justify-content-between p-2 border-bottom");
                    new_avoid_entry.append($(`<div avoid-area-name="">${query_str}</div>`));
                    new_avoid_entry.append($("<i class='ai-trash fs-lg' role='button' rem-avoid-area-entry=''></i>"));
                    new_avoid_entry.attr("id", new_id);

                    $("#avoid-area-entries").append(new_avoid_entry);
                    $("#recalculate").removeClass("disabled");
                    new_avoid_entry.find("[rem-avoid-area-entry]").on("click", function() {
                        remove_avoid_area(new_avoid_entry);
                    });
                    $("#avoid-area-collapse").collapse("show");
                    setTimeout(() => {
                        $("#avoid-area-autofill").html("");
                        $("#avoid-area-autofill").hide();
                    }, 200);
                });
            });
        } else {
            $("#avoid-area-autofill").html("");
            $("#add-avoid-area").hide();
        };
    });
    $("#avoid-area-input").on("focusout", function(event) {
        setTimeout(() => {
            $("#avoid-area-autofill:not(:hover)").hide();
        }, 200);
        if ($(this).val().toString().length == 0) {
            $("#avoid-area-autofill").html("");
        };
    });
    $("#avoid-area-input").on("focusin", () => {
        $("#avoid-area-autofill").show();
    });

    $("[avoid-state]").on("change", function() {
        $("#recalculate").removeClass("disabled");

        if (!(this as HTMLInputElement).checked) {
            for (let i = 0; i < window.tripPlannerCurrentTrip.filters.avoidStates.length; i++) {
                if (window.tripPlannerCurrentTrip.filters.avoidStates[i] == (this as HTMLInputElement).getAttribute("avoid-state")) {
                    window.tripPlannerCurrentTrip.filters.avoidStates.splice(i, 1);
                    break;
                };
            }
        }
    });

    $("[dist-unit-select]").on("change", () => {
        $("#recalculate").removeClass("disabled");
    });

    // $("#add-avoid-area").on("click", () => {
    //     const input = $("#avoid-area-input");
    //     const input_q = input.val() as string;
    //     input.val("");

    //     const new_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    //     const newAvoidArea:{id:string,name:string,bounds:null} = {
    //         id: new_id,
    //         name: input_q,
    //         bounds: null
    //     };
    //     if (window.tripPlannerCurrentTrip.filters.avoidAreas) {
    //         window.tripPlannerCurrentTrip.filters.avoidAreas.push(newAvoidArea);
    //     } else {
    //         window.tripPlannerCurrentTrip.filters.avoidAreas = [newAvoidArea];
    //     };

    //     const new_avoid_entry = $("<div avoid-area-entry-wrap=''>");
    //     new_avoid_entry.addClass("d-flex align-items-center justify-content-between px-2 border-top border-bottom");
    //     new_avoid_entry.append($(`<div avoid-area-name="">${input_q}</div>`));
    //     new_avoid_entry.append($("<i class='ai-trash' rem-avoid-area-entry=''></i>"));
    //     new_avoid_entry.attr("id", new_id);

    //     $("#avoid-area-entries").append(new_avoid_entry);
    //     $("#recalculate").removeClass("disabled");
    //     new_avoid_entry.find("[rem-avoid-area-entry]").on("click", function() {
    //         remove_avoid_area(new_avoid_entry);
    //     });
    // });

    $("#viewCalendar").on("click", open_calendar);

    $(document).on("shown.bs.modal","#calendarModal", () => {
        setTimeout(()=>{
            window.tripCalendar?.render();
        },500);
    });

    $("#abandonTripModal").on("show.bs.modal", function(event) {
        if (savedTrip_noChanges(window.tripPlannerCurrentTrip)) {
            event.preventDefault();
            $("#abandonTrip").trigger("click");
        };
    });

    $("#newTrip-saveBtn").on("click", function() {
        if (window.tripPlannerCurrentTrip.tripID != null) {
            //is already saved trip
            $("#abanonTrip-saveTripLoading").removeClass("d-none");
            $("#abandonTrip-saveTripText").addClass("d-none");
            saveTrip(window.tripPlannerCurrentTrip, window.tripPlannerCurrentTrip.name, false).then(tripID => {
                setTimeout(() => {
                    $("#abandonTrip").trigger("click");
                }, 500);
            });
        } else {
            $("#abandonTripModal").modal("hide");
            setTimeout(()=>{
                $("[save-trip-btn]").trigger("click");
            }, 500);
        };
    });

    $("[add-custom-stay]").on("click", function() {
        const stopID = $("#stopPopout").attr("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const customStayName = (document.querySelector("[add-custom-stay-name]") as HTMLElement).innerText;

        const newCustomStay = add_custom_stay_to_stop(stopData.stop, customStayName);

        stopPopout_display_added_stays(stopData.stop, window.tripPlannerCurrentTrip.filters.dist_unit);

        send_addCustomStayToStop(
            stopData.legIndex,
            stopData.stopIndex,
            newCustomStay.camp.campID,
            newCustomStay.s_date,
            newCustomStay.numNights,
            newCustomStay.camp.camp_name
        );
        $("#stays").scrollTop(0);

        inc_interaction_counter();

        $("#no-search-res-custom-stay").addClass("d-none");
        $("#staySearch").val("");
        $("#staySearch").trigger("input");

        getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
            window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
            display_trip_html(window.tripPlannerCurrentTrip, true);

            $(`a[href="#stays-${stopID}"]`).tab("show");
            $(`a[href="#stays-${stopID}"]`).trigger("shown.bs.tab");
        }).catch(e => {
            console.error(e);
        });

    });

    $("[whatToDo]").on("keydown", function(event) {
        const isEnter = event.key == "Enter";
        if (isEnter) {
            event.preventDefault();
        };
        const form = $(this).closest("form")
        const input = form.find("[whattodo]");
        if (isEnter && input.val().toString().length > 0) {

            form.trigger("submit");
        };
    });

    $(document).on("click", "[suggested-stop-feedback]", function(event) {
        event.stopImmediatePropagation();
        $("[suggestedstoptoast]").addClass("autoBreathingButton");
        setTimeout(() => {
            $("[suggestedstoptoast]").removeClass("autoBreathingButton");
        }, 3000);
    });

    init_genie_btn_draggable();

    $("#updateStopLoc").on("click", function() {
        const campID:number = parseInt(this.getAttribute("campID"));
        const stopID:string = this.getAttribute("stopID");
        if (!stopID || Number.isNaN(campID)) {
            return;
        };

        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        let camp:Campground_Data|null = null;
        let i:number
        for (i = 0; i < stopData.stop.selectedCamps.length; i++) {
            if (stopData.stop.selectedCamps[i].camp.campID == campID) {
                camp = stopData.stop.selectedCamps[i];
                break;
            };
        };
        if (camp == null) {
            for (i = 0; i < stopData.stop.altStops.length; i++) {
                if (stopData.stop.altStops[i].camp.campID == campID) {
                    camp = stopData.stop.altStops[i];
                    break;
                };
            };
        };
        if (camp == null) return;

        stopData.stop.coords = {latitude: camp.camp.latitude, longitude: camp.camp.longitude};
        stopData.stop.clusterTitle = camp.camp.city + ", " + camp.camp.administrative_area_level_1;

        for (i = 0; i < stopData.stop.altStops.length; i++) {
            const dist = distance_latLong_toMi(stopData.stop.coords, {latitude:stopData.stop.altStops[i].camp.latitude,longitude:stopData.stop.altStops[i].camp.longitude});
            stopData.stop.altStops[i].dist = dist;

            $(`[unaddedstay][id="${stopData.stop.altStops[i].camp.campID}"]`).find("[stayDistSection]").html(`Distance to stop: ${Math.round(dist)}mi`);
        };
        for (i = 0; i < stopData.stop.selectedCamps.length; i++) {
            const dist = distance_latLong_toMi(stopData.stop.coords, {latitude:stopData.stop.selectedCamps[i].camp.latitude,longitude:stopData.stop.selectedCamps[i].camp.longitude});
            stopData.stop.selectedCamps[i].dist = dist;

            $(`[addedstay][id="${stopData.stop.selectedCamps[i].camp.campID}"]`).find("[stayDistSection]").html(`Distance to stop: ${Math.round(dist)}mi`);
        };

        if ($("#stopPopout").attr("stopID") == stopID) {
            $("#stopPopout").find("[stoptitle]").html(stopData.stop.clusterTitle);
        };

        getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
            window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
            display_trip_html(window.tripPlannerCurrentTrip, true);
        });

        updateTripState(window.tripPlannerCurrentTrip);

        $("#updateStopLocModal").modal("hide");
    });

    const stopRadius = document.getElementById("stopRadius");
    stopRadius.style.setProperty('--value', `${parseInt((stopRadius as HTMLInputElement).value) - 5}%`);
    stopRadius.addEventListener("change", function() {
        this.style.setProperty('--value', `${parseInt((this as HTMLInputElement).value) - 5}%`);

        update_stayRadius_histogram("radiusHistogram");
    });

    $('[data-bs-toggle="tab"][href="#tripOverviewTab"]').parent().on("click", () => {
        if ($("#stopPopout").is(":visible")) {
            $("#stopPopout").addClass("d-none");
            document.getElementById("stopPopout").dispatchEvent(new CustomEvent("element.hide",{bubbles:true,cancelable:true}));
        }
    });

    $("[scroll-left]").on("click", function() {
        const targetId = this.getAttribute("target");
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;
        target.scrollLeft -= 75;

        $(`[scroll-right][target="${targetId}"]`).removeClass("d-none");

    });
    $("[scroll-right]").on("click", function() {
        const targetId = this.getAttribute("target");
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;
        target.scrollLeft += 75;

        $(`[scroll-left][target="${targetId}"]`).removeClass("d-none");

        if ($(target).scrollLeft() == $(target).width()) {
            $(this).addClass("d-none");
        };
    });

    $("[cllose-dropdown]").on("click", function() {
        $(this).closest(".dropdown,.dropend").dropdown("hide");
    });

    $("#copilotTextInput").on("input", () => {
        $("#copilotSubmit").removeClass("disabled");
    })

    $('#perLegRouteOptions').on("shown.bs.collapse", () => {
        const scrollEl = document.getElementById("routeOptions-scrollEl");
        scrollEl.scrollTo(0,scrollEl.scrollHeight);
    });

    $("[dismiss-genieWish-info]").on("click", () => {
        $("[genie-wish-info]").remove();
        setCookie("gw-dismiss", "t", "", 1e10);
    });

    $(document).on("click", "[rem-li]", function() {
        const li = $(this).closest("li");
        const ul = li.closest("ul");
        li.remove();

        let is_wishes_list:boolean = false;
        let parent_card = null;
        if (ul.attr("stopwishes_list") != undefined) {
            is_wishes_list = true;
            parent_card = ul.closest("[stopwisheswrapper]");
        };

        if (ul.find("li").length == 0) {
            ul.remove();
            if (is_wishes_list && parent_card != null) {
                parent_card.remove();
            };
        };
    });

    $("#hide-stop-wishes").on("click", () => {
        $("#stop-wishes-results").hide();
        $("#stop-wishes-input").show();
    });

    $("#hide-trip-wishes").on("click", () => {
        $("#trip-wishes-results").hide();
        $("#trip-wishes-input").show();
    });

    $("[use-interests]").on("change", function() {
        const form = $(this).closest("form");
        const interests:string = $("[userInterests]").val().toString();
        const curVal = form.find("[whatToDo]").val().toString();
        if ($(this).prop("checked")) {
            form.find("[whatToDo]").val(curVal + " " + interests);
            form.find("button[type='submit']").removeClass("disabled");
        } else {
            form.find("[whatToDo]").val(curVal.replace(interests, ""));
        }
    });

    $("#editInterests").on("click", () => {
        $("#userInterests-view").addClass("d-none");
        $("#userInterests-edit").removeClass("d-none");
    });
    $("#userInterests-edit-cancel").on("click", () => {
        const interests:string = $("[userInterests]").val().toString();
        $("#userInterests-edit-input").val(interests);
        $("#userInterests-view").removeClass("d-none");
        $("#userInterests-edit").addClass("d-none");
    });
    $("#userInterests-edit-save").on("click", () =>  {
        const interests:string = $("#userInterests-edit-input").val().toString();
        $("#userInterests-edit-input").val(interests);
        $("[userInterests]").val(interests);
        $("[userInterests_disp]").html(interests);
        $("#userInterests-view").removeClass("d-none");
        $("#userInterests-edit").addClass("d-none");
        update_interests(interests);
    });


    $("[whatToDo]").on("input", function() {
        const form = $(this).closest("form");
        const input = $(this);
        const btn = form.find("button[type='submit']");
        if (input.val().toString().length > 0) {
           btn.removeClass("disabled");
        } else if (!btn.hasClass("disabled")) {
            btn.addClass("disabled");
        }
    });

    $("#clear-poi-filters").on("click", () => {
        $(this).addClass("d-none");
        $(this).tooltip("hide");
        $("[poi-filter]").prop("checked",false);
        $("#poi-dropdown-wrapper .dropdown-toggle-darkBlue").removeClass("selected");
        display_pois(window.currentPOIoptions, $("#stopPopout").attr("stopID"))
    });

    $('#stopPopout [data-bs-toggle="tab"][href="#pois"]').on("hidden.bs.tab", () => {
        remove_POI_pins(true, []);
        $("#ol_map_poi_popup_card").hide();
    });
    $('#stopPopout [data-bs-toggle="tab"][href="#pois"]').on("shown.bs.tab", () => {
        $("#poi-dropdown-wrapper").scrollLeft(0);
        if ($('#stopPopout #pois').hasClass("active")) {
            $('#stopPopout #pois').addClass("active");
        }

        if (window.currentPOIoptions != undefined && window.currentPOIoptions.length > 0) {
            const stopID = $("#stopPopout").attr("stopID");
            display_pois(window.currentPOIoptions, stopID);
        } else {
            $('input[name="poi-radius"][value="5"]').trigger("change");
        };
    });

    $(document).on("change",'input[name="poi-radius"]',function(){
        $("#radius-pois").closest(".dropdown").dropdown("hide");

        if (window.tripPlannerCurrentTrip.filters.dist_unit == "km" ) {
            $("#radius-poi-filter-btn").html(`Within ${$(this).val()} km`);
        } else {
            $("#radius-poi-filter-btn").html(`Within ${$(this).val()} miles`);
        };
        let radius:number = parseInt($(this).val().toString());

        const stopID = $("#stopPopout").attr("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;

        let poi_types:number[] = $("[poi-filter]").map((idx, el) => parseInt(el.id)).toArray();


        if (!$("#poi-count-disp").hasClass("d-none")) $("#poi-count-disp").addClass("d-none");
        $("#poisLoading").show();
        $("[unaddedpoi]").remove();
        remove_POI_pins(true, []);

        if (window.tripPlannerCurrentTrip.filters.dist_unit == "km") {
            radius = meter_to_mi(radius*1000);
        };

        get_pois_for_stop(stop, stop.stopID, poi_types, radius).then(POIs => {
            $("#poisLoading").hide();
            window.currentPOIoptions = POIs;
            display_pois(POIs, stopID)
        }).catch(e => {
            $("#poisLoading").hide();
            if (e.message == "invalid-access") {
                if (Number.isNaN(parseInt(window.GAsubLevel))) {
                    //not signed in
                    $("#signUp_cardedTrialModal").find("[signUpMsg]").html("Sign up to view POIs");
                    $("#signUp_cardedTrialModal").modal("show");
                } else {
                    $("#freemium-carded-trial").find("[signUpMsg]").html("Start your free trial to view POIs");
                    $("#freemium-carded-trial").modal("show");
                };
            } else {
                console.error(e);
            };
        });
    });


    $(document).on("click", "[copilot_autofill]", function() {
		const val:string = $(this).attr("copilot_autofill");
		$("#copilotForm").find("input[type='text']").val(val);
		$("#copilotForm").trigger("submit");
	});
    $("#copilotForm").on("submit", function() {
        const inputEl:HTMLInputElement = this.querySelector("input[type='text']");
		if (inputEl == undefined) return;
		const userInput:string = inputEl.value.toString().trim();
		if (userInput.length == 0) return;

        $("#copilot-no-inputs-disp").addClass("d-none");

        $("#copilot-msg-stream").append(`<div class='message user'>${userInput}</div>`);

        inputEl.value = "";

        send_copilot_req(userInput, window.tripPlannerCurrentTrip).then(copilot_resp => {
            inputEl.value = "";
            if ("arguments" in copilot_resp) copilot_resp.arguments = JSON.parse(copilot_resp.arguments);
            handle_copilot_resp(copilot_resp, window.tripPlannerCurrentTrip);
            $(".message.bot").prepend('<img src="/static/images/genieLisa_cropped2.png"/>')
            if (! ("name" in copilot_resp)) {
				const history = {input:userInput, response: copilot_resp.message};
				if (window.copilotHistory == undefined) {
					window.copilotHistory = [history]
				} else {
					if (window.copilotHistory.length > 3) {
						window.copilotHistory.shift();
					};
					window.copilotHistory.push(history);
				};
			};
        }).catch(e => {
			console.error(e);
			$("#copilotGenieBubble").html("Looks like I'm having some trouble communicating with our server right now, sorry. Pleae try again later");
		});
    });

    $('a[href="#tripMapTab"]').on("shown.bs.tab", () => {
        $("#onRouteDropdownBtn").removeClass("d-none");
        if (window.mainTripPlannerMap.getTarget() == "stopPopoutMap") {
            window.mainTripPlannerMap.setTarget("tripPlannerMap");
            window.mainTripPlannerMap.updateSize();
        };
        setTimeout(()=>{
            center_map(window.mainTripPlannerMap, window.tripPlannerCurrentTrip);
        }, 500);
    });

    $("#stopPopout_mapShow").on("click", function() {
        if (!$("#onRouteDropdownBtn").hasClass("d-none")) {
            $("#onRouteDropdownBtn").addClass("d-none");
        };
        $("#stopPopoutMap").removeClass("d-none");
        window.mainTripPlannerMap.setTarget("stopPopoutMap");
        window.mainTripPlannerMap.updateSize();
        const stopID:string = $("#stopPopout").attr("stopID");
        if (!stopID) return;
        const stopData =get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (!stopData) return;
        zoomToStop(window.mainTripPlannerMap, stopData.stop, stopData.stop.fromUserQuery);
        $("#stayList").addClass("d-none");

        $(this).addClass("d-none");
        $("#stopPopout_mapHide").removeClass("d-none");
    });
    $("#stopPopout_mapHide").on("click", function() {
        $("#stopPopoutMap").addClass("d-none");
        $("#stayList").removeClass("d-none");
        $(this).addClass("d-none");
        $("#stopPopout_mapShow").removeClass("d-none");
    });

    $("[example_new_GenieJourney]").on("click", function() {
        const targetSelector:string = this.getAttribute("example_new_GenieJourney");
        if (!targetSelector) return;
        const target = $(targetSelector);
        if (target.length == 0) return;
        const text:string = target.html();
        $("#allInOneSearch").html(text);
        $("#tripPlannerAllInOne").trigger("submit");
    });

    $('[data-bs-toggle="tab"][href="#tripOverviewTab"]').on("hidden.bs.tab", () => {
        $("#mobile_tabs").addClass("d-none");
        $('a[data-bs-toggle="tab"][href="#tripTab"]').tab('show');

        $("#tripSummary").addClass("d-none");

        const stopPopout = document.getElementById("stopPopout");
        if (!$(stopPopout).hasClass("d-none")) {
            $(stopPopout).toggleClass("d-none d-flex");
            stopPopout.dispatchEvent(close_event);
        };
    });
    $('[data-bs-toggle="tab"][href="#tripOverviewTab"]').on("shown.bs.tab", () => {
        $("#mobile_tabs").removeClass("d-none");

        $("#tripSummary").removeClass("d-none");
    });

    $(document).on("click", "#mapInfoWindow-close", function() {
        $("#ol_map_popup_card").hide();
    });

    $(document).on("change", "[checkbox-group-toggle]", function() {
        const groupId:string = this.getAttribute("groupId");
        if (groupId == undefined) return;
        const checkboxes = $(`input[type='checkbox'][group='${groupId}']`);
        checkboxes.prop("checked",$(this).prop("checked"));
        checkboxes.trigger("change");
    });

    $("#stopPopout").find('a[href="#stays"]').on("shown.bs.tab", function() {
        const stopID = $("#stopPopout").attr("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;
        display_potential_stay_pins(stop);
    });
    $("#stopPopout").find('a[href="#stays"]').on("hidden.bs.tab", function() {
        clearLayer(window.clusterMarkerLayer);
        $("#ol_map_popup_card").hide();
    });
    $("#stopPopout").find('a[href="#staysTab_stays"]').on("shown.bs.tab", function() {
        const stopID = $("#stopPopout").attr("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;
        display_potential_stay_pins(stop);
    });
    $("#stopPopout").find('a[href="#staysTab_stays"]').on("hidden.bs.tab", function() {
        clearLayer(window.clusterMarkerLayer);
    });

    $("#stopRadius").on("change", function() {
        const stopID = $("#stopPopout").attr("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;

        const radius = parseInt($(this).val().toString());
        const coords = stop.coords;

        get_cluster(coords, radius).then(camps => {
            stop.altStops = camps;

            zoomToStop(window.mainTripPlannerMap, stop, stop.fromUserQuery);
            display_potential_stays(window.tripPlannerCurrentTrip, stop, !stop.fromUserQuery);
            display_potential_stay_pins(stop);
            $("#stopPopout").trigger("stays.displayed");

            updateStopRadius(stopData.legIndex, stopData.stopIndex, radius);
        }).catch(e => {
            console.error(e);
        })
    });

    $("[tripPrivacyBtn]").on("click", handleSharePopup);

    document.getElementById("rvFiltersContainer").addEventListener("element.hide", () => {
        $("form#searchRVrentals").trigger("submit");
    });

    $('a[href="#staysTab_rvs"]').on("shown.bs.tab", () => {
        $("form#searchRVrentals").trigger("submit");
    });
    $('a[href="#staysTab_rvs"]').on("hidden.bs.tab", () => {
        clearLayer(window.rvShareMarkerLayer);
    });

    $("#saveTripForm").on("submit", handle_saveTrip_form);

    $("[poi-filter]").on("change", function() {
        $(`#${this.id}`).prop("checked", $(this).prop("checked"));
        const dropdownParent = $(this).closest(".dropdown-menu");
        const id = dropdownParent.attr("id");
        const toggleBtn = $(`[data-bs-toggle="dropdown"][data-bs-target="${id}"]`);
        if (toggleBtn.length && toggleBtn.closest(".dropdown").hasClass("toggle-dropdown-bg-on-check")) {
            if ($(this).prop("checked")) {
                if (!toggleBtn.hasClass("selected")) toggleBtn.addClass("selected");
            } else if (dropdownParent.find("input:checked").length == 0) {
                toggleBtn.removeClass("selected");
            };
        };
        const stopID = $("#stopPopout").attr("stopID");
        display_pois(window.currentPOIoptions, stopID);
    });

    // $("[poi-filter]").on("change", function() {
    //     const stopID = $("#stopPopout").attr("stopID");
    //     const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    //     if (stopData == null) return;
    //     const stop = stopData.stop;

    //     const tabName:string = this.getAttribute("tab");
    //     const poi_type_id:number = parseInt(this.id);
    //     if (!tabName || Number.isNaN(poi_type_id)) return;

    //     const poi_result_wrap:JQuery<HTMLElement> = $(`[poi_disp][tab_name="${tabName}"]`);

    //     if (poi_result_wrap.length == 0) return;

    //     // const noFiltersDisp:JQuery<HTMLElement> = $(`#poi-noFilterDisp-${tabName}`);

    //     if ($(this).prop("checked")) {


    //         const dropdown = $(this).closest(".dropdown");
    //         if (dropdown.length && dropdown.hasClass("toggle-dropdown-bg-on-check")) {
    //             const toggleBtn = dropdown.find("button[data-bs-toggle='dropdown']")
    //             if (!toggleBtn.hasClass("selected")) toggleBtn.addClass("selected");
    //         };

    //         const radius:number = parseInt($('input[name="poi-radius"]:checked').val().toString());
    //         get_pois_for_stop(stop, stop.stopID, [poi_type_id], radius).then(POIs => {
    //             display_pois(POIs, stopID)
    //         }).catch(e => {
    //             console.error(e);
    //         });
    //     } else {
    //         poi_result_wrap.find(`[type_id="${poi_type_id}"]`).remove();
    //         // if (poi_result_wrap.children().length == 0) {
    //         //     noFiltersDisp.removeClass("d-none");
    //         //     $(`[poi_disp_bg][tab_name="${tabName}"]`).css("background-size","auto");
    //         // };
    //         remove_POI_pins(false, [poi_type_id]);

    //         const dropdown = $(this).closest(".dropdown");
    //         if (dropdown.length && dropdown.hasClass("toggle-dropdown-bg-on-check")) {
    //             if (dropdown.find(".dropdown-menu").find("input[type='checkbox']:checked").length == 0) {
    //                 const toggleBtn = dropdown.find("button[data-bs-toggle='dropdown']")
    //                 toggleBtn.removeClass("selected");
    //             };
    //         };

    //         if ($("[poi-filter]:checked").length == 0) {
    //             const selected_poi_types = $("[poi-filter]").map((idx, el) => parseInt(el.id)).toArray();
    //             const radius:number = parseInt($('input[name="poi-radius"]:checked').val().toString());
    //             get_pois_for_stop(stop, stop.stopID, selected_poi_types, radius).then(POIs => {
    //                 display_pois(POIs, stopID)
    //             }).catch(e => {
    //                 console.error(e);
    //             });
    //         };
    //     };
    // });

    $("#reverseTrip").on("click", () => {
        window.tripPlannerCurrentTrip = reverseTrip(window.tripPlannerCurrentTrip);

        updateTripState(window.tripPlannerCurrentTrip).catch(e => {
            console.error(e);
        })

        getTripHTML(window.tripPlannerCurrentTrip).then(html => {
            window.tripPlannerCurrentTrip.stopListHTML = html;
            display_trip_html(window.tripPlannerCurrentTrip, false);

            getTripDirections(window.tripPlannerCurrentTrip).then(directions => {
                window.tripPlannerCurrentTrip.directions = directions;
                display_route(window.tripPlannerCurrentTrip);
            }).catch(e => {
                console.error(e);
            });
        }).catch(e => {
            console.error(e);
        });
    });

    $("[stopPopout-poiTab]").on("shown.bs.tab", () => {
        $("#poiCategoryDisp").show();
        $("#poiCategoryTabs").addClass("d-none");
    });

    $("[closeTabCategory]").on("click", () => {
        $("#poiCategoryDisp").hide();
        $("#poiCategoryTabs").removeClass("d-none");
        $("a[href='#pois-hidden']").tab("show");
    });

    $("#staysSortBy").on("change", function() {
        const sortBy:string = $(this).val().toString();
        sort_stays(sortBy, $("#stayList"));
    });

    $("#addAllWishes").on("click", function() {
        const updateWishesData:Array<{legIndex:number,stopIndex:number,wishes:string[]}> = [];

        $("#wholeTripWishesOutput").children().each(function() {
            const addWishesEl:JQuery<HTMLElement> = $(this).find("[addWishes]")

            const stopWishes_list:string = $(this).find("[stopWishes_list]").html();

            const stopID = addWishesEl.attr("stopID");
            const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
            if (stopData == null) return;
            const stop = stopData.stop;
            const legIndex = stopData.legIndex;
            const stopIndex = stopData.stopIndex;

            if (stop.wishes) {
                stop.wishes.push(stopWishes_list);
            } else {
                stop.wishes = [stopWishes_list];
            };

            $(mustache.render(genie_wishes_added_disp,{})).insertAfter(addWishesEl);
            addWishesEl.remove();

            updateWishesData.push({
                legIndex: legIndex,
                stopIndex: stopIndex,
                wishes: stop.wishes
            });
        });

        send_updateTripWishes(updateWishesData).then(() => {
            getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
                window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
                display_trip_html(window.tripPlannerCurrentTrip, true);
            });
        });
    });

    $("[dropdown-checkboxes-label]").each(function() {
        const dropdownLabel:JQuery<HTMLElement> = $(this).find("[dropdown-label]");

        const dropdown:JQuery<HTMLElement> = $(this).find(".dropdown-menu");
        if (dropdown == undefined) return;
        const checkboxes:JQuery<HTMLElement> = dropdown.find('.dropdown-item input[type="checkbox"]');

        function updateSubTitle() {
            const selectedLabels = Array.from(checkboxes)
            .filter(checkbox => (checkbox as HTMLInputElement).checked)
            .map(checkbox => checkbox.nextElementSibling.textContent.trim())
            .join(", ");
            dropdownLabel.text(selectedLabels || '...');
        };
        checkboxes.each(function() {
            $(this).on("change", updateSubTitle);
        });
        updateSubTitle();
    });

    $("#cancel-route-options").on("click", function() {
        set_filters_display(window.tripPlannerCurrentTrip);
    })

    $("[add-per-leg-setting]").on("click", function() {
        const newSetting = $(document.querySelector("[per-leg-mile-setting]")).clone();
        newSetting.find("[perLeg_routeOptions_emptyState]").show();
        newSetting.find("[perLeg_routeOptions_selectedLegs]").html("");
        newSetting.find("[perLeg_routeOptions_select]")
        newSetting.find("[per-leg-mile-setting-input]").val("");
        // newSetting.find("[perLegRouting_legOption]").removeClass("d-none");
        // $("#perLegRouteOptions").append(newSetting);

        newSetting.insertBefore($(this));
        init_perLeg_routeOptions_listeners();
    });

    $("#vehicleType,#avoid-highways,#avoid-tolls,#avoid-tunnels,#avoid-ferries,#drive-dist,#driveDistOption").on("change", () => {
        $("#recalculate").removeClass("disabled");
    })

    $("#recalculate").on("click", function() {
        set_tripFilters(window.tripPlannerCurrentTrip, null);
        show_map_loadingIcon("Recalculating your route");
        $(this).addClass("disabled");

        const selected_legs = get_selected_legs_for_recalc()

        recalc(window.tripPlannerCurrentTrip, selected_legs).then(trip => {
            window.tripPlannerCurrentTrip = trip;
            hide_map_loadingIcon();
            display_trip(trip, !$("#stopPopout").is(":visible"));

            $('[data-bs-toggle="tab"][href="#tripOverviewTab"]').tab("show");
        }).catch(e => {
            hide_map_loadingIcon();
            $(this).removeClass("disabled");
            console.error(e);
        });
    });

    $("#staySearch").on("input", function() {
        const MAX_DISTANCE_RATIO = 0.5;
        const searchText_orig:string = $(this).val().toString();
        const searchText:string = $(this).val().toString().toLowerCase();
        const searchText_noSpaces:string = searchText.replace(/\s/g, '');;
        const searchItems:JQuery<HTMLElement> = $("#stayList").find("[unAddedStay]");

        const hiddenCampIDs:number[] = [];

        if (searchText_noSpaces.length == 0) {
            searchItems.each(function(){
                $(this).removeClass("!search");
                if (!this.classList.toString().includes("!")) {
                    $(this).removeClass("d-none");
                };
            });
            $("#staysSortBy").find("[value='match']").prop("selected",true);
            $("#staysSortBy").trigger("change");

        } else {
            // $("#staysSortBy").find("[value='search']").prop("selected",true);
            $("#staysSortBy").val("search");

            const items:{element:JQuery<HTMLElement>,normalizedDistance:number,normalized_substring_distance:number,includesSearchText:boolean}[] = [];
            searchItems.each(function() {
                const itemText:string = $(this).find("[camp_name]").text().toLocaleLowerCase();
                const itemText_noSpaces:string = itemText.replace(/\s/g, '');;
                const distance:number = levenshteinDistance(itemText_noSpaces, searchText_noSpaces);
                const min_len = Math.min(itemText_noSpaces.length, searchText_noSpaces.length);
                const substring_distance = levenshteinDistance(itemText_noSpaces.slice(0,min_len), searchText_noSpaces.slice(0,min_len));
                const normalizedDistance = distance / searchText_noSpaces.length;
                const normalized_substring_distance = substring_distance / min_len;

                items.push({
                    element: $(this),
                    normalizedDistance: normalizedDistance,
                    normalized_substring_distance: normalized_substring_distance,
                    includesSearchText: itemText.includes(searchText)
                });
            });
            items.sort((a, b) => {
                if (a.includesSearchText && !b.includesSearchText) return -1;
                if (!a.includesSearchText && b.includesSearchText) return 1;

                if (a.normalized_substring_distance !== b.normalized_substring_distance) return a.normalized_substring_distance - b.normalized_substring_distance;
                return a.normalizedDistance - b.normalizedDistance;
            });
            $("#stayList").html("");

            items.forEach(item => {
                if (item.includesSearchText || item.normalizedDistance <= MAX_DISTANCE_RATIO || item.normalized_substring_distance <= MAX_DISTANCE_RATIO) {
                    //TODO:only show if not hidden from filters
                    item.element.removeClass("!search");
                    if (!item.element[0].classList.toString().includes("!")) {
                        item.element.removeClass('d-none');
                    };
                } else {
                    if (!item.element.hasClass("!search")) {
                        item.element.addClass("!search");
                    };
                    if (!item.element.hasClass("d-none")) {
                        item.element.addClass('d-none');
                    };
                };

                if (item.element[0].classList.toString().includes("!")) {
                    hiddenCampIDs.push(parseInt(item.element.attr("id")));
                }

                item.element.appendTo('#stayList');
            });
        };


        update_stayPin_opacity(hiddenCampIDs);

        document.getElementById("stopPopout").dispatchEvent(new CustomEvent("stays.displayed"));

        const no_results_customStayDialog = $("#no-search-res-custom-stay");
        if ($("#stayList").children().filter(":visible").length == 0) {
            $("[add-custom-stay-name]").text(searchText_orig);
            no_results_customStayDialog.removeClass("d-none");
        } else if (!no_results_customStayDialog.hasClass("d-none")) {
            no_results_customStayDialog.addClass("d-none");
        };

        const n_stay_results = $("#stayList").find("[unaddedstay]").filter(":not(.d-none)").length;
        $("#stopPopout_n_camps").html(`Showing ${n_stay_results} results`);
    });

    $("#editNotes").on("focusout", function() {
        const notes:string = $(this).html();

        const stopID = this.getAttribute("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;
        const legIndex = stopData.legIndex;
        const stopIndex = stopData.stopIndex;

        stop.notes = notes;

        send_updateTripNotes([{legIndex:legIndex,stopIndex:stopIndex,notes:notes}]).then(() => {
            getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
                window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
                display_trip_html(window.tripPlannerCurrentTrip, true);
            }).catch(e => {
                console.error(e);
            });
        });
    });

    $("#stopPopoutCollapse").on("hidden.bs.collapse", () => {
        $("#stopPopoutCollapseTrigger").css("transform","translate(-50%,0%)");
        $("#stopPopoutCollapseTrigger").find("i").toggleClass("ai-chevron-left ai-chevron-right");
    });
    $("#stopPopoutCollapse").on("shown.bs.collapse", () => {
        $("#stopPopoutCollapseTrigger").css("transform","translate(0%,0%)");
        $("#stopPopoutCollapseTrigger").find("i").toggleClass("ai-chevron-left ai-chevron-right");
    });

    // $("#copilotCollapse").on("hidden.bs.collapse", () => {
    //     $("#copilotCollapseTrigger").css("transform","translate(-50%,0%)");
    //     $("#copilotCollapseTrigger").find("i").toggleClass("ai-chevron-left ai-chevron-right");
    // });
    // $("#copilotCollapse").on("shown.bs.collapse", () => {
    //     $("#copilotCollapseTrigger").css("transform","translate(0%,0%)");
    //     $("#copilotCollapseTrigger").find("i").toggleClass("ai-chevron-left ai-chevron-right");
    // });

    $("[overviewTabTrigger").on("click", function() {
        $("a[href='#tripOverviewTab'][data-bs-toggle='tab']").tab("show");
    });

    $("[close-menu]").on("click", function() {
        const targetId:string = this.getAttribute("target");
        if (targetId == undefined) return;
        const target:HTMLElement = document.getElementById(targetId);
        if (target == undefined || target == null) return;
        $(target).toggleClass("d-none d-flex");
        target.dispatchEvent(close_event);
    });
    $("[show-menu]").on("click", function() {
        const targetId:string = this.getAttribute("target");
        if (targetId == undefined) return;
        const target:HTMLElement = document.getElementById(targetId);
        if (target == undefined || target == null) return;
        $(target).toggleClass("d-none d-flex");
        target.dispatchEvent(show_event);
    });

    document.getElementById("copilotInput").addEventListener("element.show", () => {
        $('#personalGenieBtn').hide();
        $("#copilotCollapse").collapse("show");

        $("#personalGenie-welcomeMsg").addClass("d-none");
        setCookie("g-msg","t","", null);
    });
    document.getElementById("copilotInput").addEventListener("element.hide", () => {
        $('#personalGenieBtn').show();
    });

    document.getElementById("copilot-msg-stream").addEventListener("DOMNodeInserted", function(e) {
        $("#copilotAutoScroll").scrollTop($("#copilot-msg-stream").prop('scrollHeight'));
    });
    // $("[closeStayFilters]").on("click", () => {
    //     filter_potential_stays($("#stopPopout").find("#stayList"));
    // });
    $("[amenityFilter],[activityFilter],#s2nFilter").on("change", () => {
        filter_potential_stays($("#stopPopout").find("#stayList"));
    });
    $("#siteLength,#sitePrice").on("input", () => {
        filter_potential_stays($("#stopPopout").find("#stayList"));
    });

    $("#clearStayFilters").on("click", () => {
        const filterPanel:JQuery<HTMLElement> = $("#stayFilters");
        filterPanel.find("#s2nFilter").prop("checked",false);
        filterPanel.find("[amenityFilter]").prop("checked",false);
        filterPanel.find("[activityFilter]").prop("checked",false);
        filterPanel.find("#siteLength").val("");
        filterPanel.find("#sitePrice").val("");
        filter_potential_stays($("#stopPopout").find("#stayList"));
    });

    $("[view-stay-filters]").on("click", () => {
        $("#mainStopPopout").addClass("d-none");
        $("#stayFilters").removeClass("d-none");
    });
    $("[view-poi-filters]").on("click", () => {
        $("#mainStopPopout").addClass("d-none");
        $("#poiFilters").removeClass("d-none");
    })
    $("[view-mainStopPopout]").on("click", () => {
        $("#mainStopPopout").removeClass("d-none");
        if (!$("#stayFilters").hasClass("d-none")) $("#stayFilters").addClass("d-none");
        if (!$("#poiFilters").hasClass("d-none")) $("#poiFilters").addClass("d-none");
    });

    $("[toggle-visibility]") .on("click", function() {
        const targetSelector:string|undefined = $(this).attr("target");
        if (targetSelector == undefined) return;
        const target:JQuery<HTMLElement> = $(targetSelector);
        if (target.is(":visible")) {
            target.hide();
        } else {
            target.show();
        };
        setTimeout(() => {
            target.find("input").trigger("focus");
        }, 100);
    });

    $("#startTrial_blockInteraction").on("shown.bs.modal",function() {
        const attachRewardfulForms = () => {
            if (typeof Rewardful !== "undefined" && Rewardful.Forms) {
                Rewardful.Forms.attach();
                $(this).find("[name='affiliateID']").val(Rewardful.affiliate.id);
                clearInterval(interval);
            }
        };

        const interval = setInterval(attachRewardfulForms, 100);
    });

};

export function init_stopPopout_ui_listeners() {
    $("[remove-stay]").off("click");
    $("[remove-stay]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        const campID:number = parseInt($(this).attr("campID"));

        const stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null = get_stop_from_stopID(stopID,window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop:Trip_Cluster_v2 = stopData.stop;
        const legIndex:number = stopData.legIndex;
        const stopIndex:number = stopData.stopIndex;

        const removedCamp:Campground_Data|null = remove_stay_from_stop(stop, campID);
        if (removedCamp != null) {
            stop.altStops.push(removedCamp);
            display_potential_stays(window.tripPlannerCurrentTrip, stop, !stop.fromUserQuery);
        };

        send_removeStay(legIndex, stopIndex, campID);

        $("#stopPopout").find("#stopPopout_addedStays").find(`#${campID}`).remove();

        getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
            window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
            display_trip_html(window.tripPlannerCurrentTrip, false);
            document.dispatchEvent(new CustomEvent("directionsUpdateNeeded"));
        }).catch(e => {
            console.error(e);
        });
    });
};